import { StreakSummaryResponseV2 } from "@cede/types";
import { QueryKeys } from "@cede/utils";
import { useHubUser } from "@/hooks/user/useHubUser";
import { getRecentlyCancelledStreaks } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

/**
 * Fetches V2 streaks that were recently cancelled due to autopilot config updates.
 * Used to show notifications to users whose autopilots were stopped.
 */
export const useRecentlyCancelledStreaks = () => {
  const { auth, authenticated } = useHubUser();

  const query = useQuery({
    queryKey: [QueryKeys.AUTOMATIC_STREAKS, "recently-cancelled"],
    queryFn: async (): Promise<StreakSummaryResponseV2[]> => getRecentlyCancelledStreaks(auth),
    enabled: authenticated,
    staleTime: 60_000, // 1 minute
  });

  return {
    cancelledStreaks: query.data ?? [],
    hasCancelledStreaks: (query.data?.length ?? 0) > 0,
    isLoading: query.isLoading,
  };
};
